














export default {
  name: 'Header',
  props: {
    slotComponent: {},
    slotProps: {},
    title: {
      type: String,
    },
  },
  methods: {
    close(){
      this.$emit('close')
    }
  }
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppModal/components/Header.vue